import React from 'react';
import { Row, Typography } from '@app/ui';
import { useTranslation } from 'react-i18next';

import connect from '@app/utils/connect';
import combineActions from '@app/utils/combineActions';
import changeDelimiter from '@app/actions/csv/changeDelimiter';
import sendNotification from '@app/actions/notifications/send';
import { User } from '@app/types/api';

import { CardWithActions } from '@app/components/common/CardWithActions';

import { SETTINGS_TABS } from '@app/settings/constants/tabs';
import { useRegionForm } from '@app/settings/hooks/useRegionForm';

import RegionForm from './RegionForm';

export type RegionProps = {
    user: User;
    sendNotification: (msg: string, opts?: any) => void;
    changeDelimiter: (csvDelimiter) => Promise<void>;
};

export const Region = ({
    user,
    sendNotification,
    changeDelimiter,
}: RegionProps) => {
    const { t } = useTranslation('settings');
    const { formik, saveRegionalSettings, clearAllFields, isSaveDisabled } =
        useRegionForm(user, changeDelimiter, sendNotification);

    return (
        <div className="user-settings-region">
            <Row>
                <Typography.Title
                    style={{
                        fontWeight: 600,
                        fontSize: 16,
                        marginTop: '0.5em',
                        marginBottom: '1.5em',
                    }}
                >
                    {t('userSettings.region.title')}
                </Typography.Title>
            </Row>

            <Row>
                <CardWithActions
                    actions={{
                        onCancel: {
                            label: t('userSettings.region.actions.clearAll'),
                            method: clearAllFields,
                        },
                        onConfirm: {
                            label: t('userSettings.region.actions.saveChanges'),
                            method: saveRegionalSettings,
                            isDisabled: isSaveDisabled,
                        },
                    }}
                    title={t('userSettings.region.cardTitle')}
                    icon={SETTINGS_TABS.REGION.iconDef}
                >
                    <RegionForm formInstance={formik} />
                </CardWithActions>
            </Row>
        </div>
    );
};

export default connect(
    ['user'],
    combineActions({
        sendNotification,
        changeDelimiter,
    }),
)(Region);
